module.exports = __webpack_public_path__ + "img/gal_28.c6a45b5b.png";